import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Premium Volumes', '✅ 5 Bonus Kits'], ['✅ 120 Ready Classes', '✅ 52 Weekly Programs'], ['✅ 365 Daily Routines']];
export function Hero() {
  return <>
      <section className="w-full bg-navy px-4 py-5 text-white sm:py-7" style={{
      backgroundColor: "#2B5C7B",
      backgroundImage: "none"
    }} data-id="element-109" data-mp="4lqkazhutj53">
        <div className="mx-auto max-w-4xl text-center" data-id="element-110" data-mp="128fq7kfogfw8">
          <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex whitespace-nowrap rounded-full border border-sage-light/40 bg-white/5 px-3 py-1 text-[9px] font-bold uppercase tracking-[0.08em] text-sage-light sm:text-[10px]" style={{
          fontSize: "7px"
        }} data-id="element-111" data-mp="xae9h65q4snx">
            🧘🏻‍♀️ THE COMPLETE SYSTEM FOR STRETCHING INSTRUCTORS
          </motion.span>

          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05
        }} className="mx-auto mt-2 max-w-xl font-serif text-3xl leading-[0.98] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-112" data-mp="3814ehx9xecs1">
            The Complete Stretching<br data-id="element-113" data-mp="39cfotbutzlzb" />
            <span className="text-sage-light" data-id="element-114" data-mp="3e9fuvmrokoqf">Teacher System™</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.12
        }} className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-white/90 sm:text-base" data-id="element-115" data-mp="3eb8xmqz6aot5">
            Ready-to-use lesson plans, stretching sequences, teaching guides, and printable resources for professional stretching instructors.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-2 max-w-2xl text-center" data-id="element-116" data-mp="2hincujl6smm0">
            <p className="text-xs font-bold uppercase tracking-[0.12em] text-sage-light" data-id="element-117" data-mp="s2td3kfiu7p7">📦 Everything You Get Instantly</p>
            <div className="mt-1.5 space-y-1 text-xs font-medium text-white/90 sm:text-sm" data-id="element-118" data-mp="n98crlqgh1mu">
              {benefitRows.map(row => <p key={row.join('-')} className="flex justify-center gap-x-4 whitespace-nowrap sm:gap-x-7" data-id="element-119" data-mp="i9vu7d6magq2">
                  {row.map(benefit => <span key={benefit} data-id="element-120" data-mp="1b1fcmuve3qr0">{benefit}</span>)}
                </p>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-1.5 max-w-4xl" data-id="element-121" data-mp="162ugp7n67t8d">
            <div className="mx-auto w-full max-w-md overflow-hidden rounded-[2.5rem] sm:max-w-lg sm:rounded-[3rem]" data-id="element-122" data-mp="x0l4mdc97rsv">
              <img src="https://cdn.magicpatterns.com/uploads/xqHMmuYpmUNXvWYHpv7Q7w/ChatGPT_Image_8_sept_2026,_09_59_14_a.m..png" alt="The Complete Stretching Teacher System main product mockup" className="block w-full object-contain" data-id="element-123" data-mp="3lque9na2654j" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-1.5" data-id="element-124" data-mp="21bfulng27bte">
            <CTAButton href="#complete-package" pulse size="large" data-id="element-125" data-mp="2b2ai0v51khgf">GET INSTANT ACCESS</CTAButton>
            <p className="mx-auto mt-2 max-w-3xl text-xs leading-relaxed text-white/70 sm:text-sm" data-id="element-126" data-mp="2fz101o0epn4h">📄 High-Quality PDF <span className="mx-1" data-id="element-127" data-mp="2kxc7xt755nk2">·</span> 🖨️ Printable Resources <span className="mx-1" data-id="element-128" data-mp="2ozz3o56xnsmj">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-129" data-mp="2p1a5w0kqcsbj">·</span> 🔒 Secure Payment <span className="mx-1" data-id="element-130" data-mp="2u03mi1vbczfx">·</span> 🛡️ 7-Day Purchase Protection</p>
          </motion.div>
        </div>
      </section>

      <section className="border-y border-amber bg-amber-pale px-4 py-5 text-navy" data-id="element-131" data-mp="unrdt69gy1xm">
        <div className="mx-auto max-w-3xl text-center" data-id="element-132" data-mp="zkrawrocbucl">
          <p className="text-sm font-bold sm:text-base" data-id="element-133" data-mp="zndq9dhh3e5d">🤸🏻 Launch offer active — Price increases when the timer hits zero</p>
          <div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-134" data-mp="3vi6x8hh604s3"><div className="h-full w-[72%] rounded-full bg-amber" data-id="element-135" data-mp="e9jvzpomb1ps" /></div>
          <p className="mt-2 text-xs font-medium text-slate" data-id="element-136" data-mp="e7hb1k2bnyrx">72% of launch spots already claimed</p>
        </div>
      </section>
    </>;
}